<template>
  <div>
    <b-overlay :show="loading" rounded="sm" :style="loading ? 'height:800px;overflow:hidden;' : ''">
      <PageValidate ref="basicInfoObserver" :productCatsRef="['btnAddCompanyCat']">
        <template v-slot:PageBody>

          <div class="CenterCard">
            <BasicPageTop :Name="$t('lbl_EMPBE_CompanyInfo_Basic_BasicInformation')">
              <template v-slot:Body>
                <div class="BasicTop-Card" v-html="$t('lbl_EMPBE_CompanyInfo_Basic_BasicInformation_Blue_p',{href:GetBasicInformation})">
                </div>
              </template>
            </BasicPageTop>
            <div>
              <div class="row">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{ $t('lbl_EMPBE_CompanyInfo_Basic_CompanyName_En') }} <span class="text-danger">*</span>
                  </div>
                  <div class="Input_Label_Right"><span class="text-danger">*</span>&nbsp; {{
                    $t('lbl_EMPBE_CompanyInfo_Basic_Required')}}</div>
                </div>
                <div class="col-12" :class="{ 'has-company-name-br-hint': showCompanyNameBrHint }">
                  <textbox ControlId="nameEng" :title="$t('lbl_EMPBE_CompanyInfo_Basic_CompanyName_En')"
                    :placeholder="$t('lbl_EMPBE_CompanyInfo_Basic_CompanyName_En_PlaceOther')" max="70"
                    v-model="form.basicInfo.nameEng" CharLimit="CheckEnglishChar"
                    :mandatory="$t('lbl_EMPBE_CompanyInfo_Basic_CompanyName_En') + $t('lbl_IsRequire')"
                    :disabled="isCompanyNameFieldDisabled">
                    <template v-if="showCompanyNameBrHint" #footer>
                      <p class="company-name-br-hint">
                        {{ $t('lbl_EMPBE_CompanyInfo_Basic_CompanyName_BrHint_Prefix') }}
                        <router-link
                          v-if="!fromAdmin"
                          to="/businessDocuments/default"
                        >{{ $t('lbl_EMPBE_CompanyInfo_Basic_CompanyName_BrHint_Link') }}</router-link>
                        <a
                          v-else
                          href="javascript:;"
                          @click.prevent="openSupplierBusinessDocuments && openSupplierBusinessDocuments()"
                        >{{ $t('lbl_EMPBE_CompanyInfo_Basic_CompanyName_BrHint_Link') }}</a>{{ $t('lbl_EMPBE_CompanyInfo_Basic_CompanyName_BrHint_Suffix') }}
                      </p>
                    </template>
                  </textbox>
                  <CompanyFieldApprovalResults usage-type="companyNameE" />
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <textbox ControlId="shortNameE" :title="$t('lbl_EMPBE_CompanyInfo_Basic_CompanyShortName_En')"
                    style="margin-bottom: 0px !important;" CharLimit="CheckEnglishChar"
                    :placeholder="$t('lbl_EMPBE_CompanyInfo_Basic_CompanyShortName_En_PlaceOther')" max="40"
                    v-model="form.basicInfo.shortNameE"
                    :mandatory="$t('lbl_EMPBE_CompanyInfo_Basic_CompanyShortName_En') + $t('lbl_IsRequire')">
                  </textbox>
                  <CompanyFieldApprovalResults  style="margin:4px 0  !important;" usage-type="companyShortNameE" />
                  <div class="nameEng_P" style="margin-bottom: 25px !important;">
                    {{ $t('lbl_EMPBE_CompanyInfo_Basic_CompanyName_En_P') }}</div>
                </div>
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{ $t('lbl_EMPBE_CompanyInfo_Basic_CompanyName_Cn') }} <span class="text-danger">*</span>
                  </div>
                  <div class="Input_Label_Right"></div>
                </div>
              </div>
              <div class="row">
                <div class="col-12" :class="{ 'has-company-name-br-hint': showCompanyNameBrHint }">
                  <textbox ControlId="nameTrad" :title="$t('lbl_EMPBE_CompanyInfo_Basic_CompanyName_Cn')"
                    :placeholder="$t('lbl_EMPBE_CompanyInfo_Basic_CompanyName_Cn_PlaceOther')" max="40"
                    v-model="form.basicInfo.nameTrad"
                    :mandatory="$t('lbl_EMPBE_CompanyInfo_Basic_CompanyName_Cn') + $t('lbl_IsRequire')"
                    :disabled="isCompanyNameFieldDisabled">
                    <template v-if="showCompanyNameBrHint" #footer>
                      <p class="company-name-br-hint">
                        {{ $t('lbl_EMPBE_CompanyInfo_Basic_CompanyName_BrHint_Prefix') }}
                        <router-link
                          v-if="!fromAdmin"
                          to="/businessDocuments/default"
                        >{{ $t('lbl_EMPBE_CompanyInfo_Basic_CompanyName_BrHint_Link') }}</router-link>
                        <a
                          v-else
                          href="javascript:;"
                          @click.prevent="openSupplierBusinessDocuments && openSupplierBusinessDocuments()"
                        >{{ $t('lbl_EMPBE_CompanyInfo_Basic_CompanyName_BrHint_Link') }}</a>{{ $t('lbl_EMPBE_CompanyInfo_Basic_CompanyName_BrHint_Suffix') }}
                      </p>
                    </template>
                  </textbox>
                  <CompanyFieldApprovalResults usage-type="companyNameS" />
                </div>
                <div class="col-12">
                  <textbox ControlId="shortNameT" :title="$t('lbl_EMPBE_CompanyInfo_Basic_CompanyShortName_Cn')"
                    :placeholder="$t('lbl_EMPBE_CompanyInfo_Basic_CompanyShortName_Cn_PlaceOther')" max="20"
                    :mandatory="$t('lbl_EMPBE_CompanyInfo_Basic_CompanyShortName_Cn') + $t('lbl_IsRequire')"
                    v-model="form.basicInfo.shortNameT">
                  </textbox>
                  <CompanyFieldApprovalResults usage-type="companyShortNameS" />
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-2">
                  <div class="Input_Label_Left">
                    <TipsAndPrivewDilog :id="'EMPBE_CompanyInfoCenter_EboothUrl_Tips'"
                      :Title="$t('lbl_EMPBE_CompanyInfo_Basic_Website_Tips')">
                      <template v-slot:Text>
                        {{ $t('lbl_EMPBE_CompanyInfo_Basic_Website') }}
                      </template>
                    </TipsAndPrivewDilog>
                  </div>
                </div>
                <div class="col-12">
                  <div :class="(form.basicInfo.subDomainStatusCode == 'A' ? ' ': 'AllButtomMargin ' ) + ' WebSite_Show_All'"
                    v-html="$t('lbl_EMPBE_CompanyInfo_Basic_Website_P', { companyShortNameEn: GetWebSites })">
                  </div>
                  <div class="FormState">
                    <div v-if="AplusABCBasicBooth">
                      <div v-if="form.basicInfo.subDomainStatusCode == 'A'" class="Approved">
                        <img :src="cdnURL+'CheckCircle.svg'"/><span >{{$t("lbl_EMPBE_Approved")}}</span>
                      </div>
                      <div  v-else-if="form.basicInfo.subDomainStatusCode == 'R' && !isCompanyShortNameDirty" class="Rejected">
                        <img :src="cdnURL+'Error.svg'"/><span >{{$t("lbl_EMPBE_Rejected")}}</span>
                      </div>
                      <div v-else-if="form.basicInfo.subDomainStatusCode == 'P' && isCompanyShortNameDirty " class="Pending">
                        <img :src="cdnURL+'schedule.svg'"/><span >{{$t("lbl_EMPBE_Pending")}}</span>
                      </div>
                    </div>
                    <div class="unlock" v-else>
                      <img :src="cdnURL+'Lock.svg'"/><span >{{$t("lbl_EMPBE_Upgrade")}}</span>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="cardContent AllButtomMargin website_Size" v-if="form.basicInfo.subDomainStatusCode == 'A'  " v-html="$t('lbl_EMPBE_CompanyInfo_Basic_Website_Tips_P')" >
                  </div>
                </div>
              </div>
            </div>
            <div>
              <!-- Free(Guest) 不展示成立年份 -->
              <div class="row" v-if="AplusABCBasicBooth">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{ $t('lbl_EMPBE_CompanyInfo_Basic_Year') }} <span class="text-danger">*</span>
                  </div>
                </div>
                <div class="col-12">
                  <datePicker ControlId="establishment" input-class="datepicker-here form-control digits"
                    id="establishment" class="w-100" :minimumView="'year'" v-model="form.basicInfo.establishment"
                    :maximumView="'year'" :disabledDates="disabledDates" :format="'yyyy'"
                    :title="$t('lbl_EMPBE_PleaseSelect')"
                    :mandatory="$t('lbl_EMPBE_CompanyInfo_Basic_Year') + $t('lbl_IsRequire')">
                  </datePicker>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{ $t('lbl_EMPBE_CompanyInfo_Basic_Employees') }} <span class="text-danger">*</span>
                  </div>
                </div>
                <div class="col-12">
                  <selection ControlId="employee" class="w-100" :title="$t('lbl_EMPBE_PleaseSelect')"
                    v-model="form.basicInfo.employee" :options="SelectOptions.EmployeesOptions"
                    :mandatory="$t('lbl_EMPBE_CompanyInfo_Basic_Employees') + $t('lbl_IsRequire')">
                  </selection>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{ $t('lbl_EMPBE_CompanyInfo_Basic_FactoriesWorldwide') }} <span class="text-danger">*</span>
                  </div>
                </div>
                <div class="col-12">
                  <textbox type="number" v-model="form.basicInfo.totalOffice" :rules="{ required: true, min_value: 1 }"
                    ControlId="totalOffice" :title="$t('lbl_EMPBE_PleaseEnter_Number')"
                    :mandatory="$t('lbl_EMPBE_CompanyInfo_Basic_FactoriesWorldwide') + $t('lbl_IsRequire')"></textbox>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{ $t('lbl_EMPBE_CompanyInfo_Basic_TotalSpace') }} 
                  </div>
                </div>
                <div class="MoreDivInLine_16 col-12">
                  <div class="MoreDivInLine_Row_7">
                    <selection ContolId="officeSpace" :title="$t('lbl_EMPBE_PleaseSelect')"
                      v-model="form.basicInfo.officeSpace" label="text" :options="GetTotalNumber">
                    </selection>
                  </div>
                  <div class="MoreDivInLine_Row_5">
                    <selection ContolId="unitOfSpace" :title="$t('lbl_EMPBE_CompanyInfo_Basic_Area')"
                      v-model="form.basicInfo.unitOfSpace" label="text" :options="SelectOptions.UnitsOfAreaOptions">
                    </selection>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{ $t('lbl_EMPBE_CompanyInfo_Basic_PubliclyListed') }}
                  </div>
                </div>
                <div class="col-12">
                    <switchIput  class="mt-2" ControlId="isPubliclyListed" 
                    :left="$t('lbl_EMPBE_Yes')"
                    :right="$t('lbl_EMPBE_No')"
                    v-model="form.basicInfo.isPubliclyListed">
                    </switchIput>
                </div>
                <div class="MoreDivInLine_16 col-12" v-if="form.basicInfo.isPubliclyListed">
                  <div class="MoreDivInLine_Row">
                    <selection ContolId="stockExchanges" :title="$t('lbl_EMPBE_CompanyInfo_Basic_StockExchange')"
                      :mandatory="$t('lbl_EMPBE_CompanyInfo_Basic_StockExchange') + $t('lbl_IsRequire')"
                      v-model="form.basicInfo.stockExchanges" label="text" :options="SelectOptions.SRSNOptions">
                    </selection>
                  </div>
                  <div class="MoreDivInLine_Row">
                    <textbox type="text" v-model="form.basicInfo.stockCode" 
                      :title="$t('lbl_EMPBE_CompanyInfo_Basic_stockCode')"
                      :mandatory="$t('lbl_EMPBE_CompanyInfo_Basic_stockCode') + $t('lbl_IsRequire')"></textbox>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{ $t('lbl_EMPBE_CompanyInfo_Basic_IsHaveWebSite') }}
                  </div>
                </div>
                <div class="col-12">
                  <textbox ControlId="Companywebsite"
                    :placeholder="$t('lbl_EMPBE_CompanyInfo_Basic_IsHaveWebSite_PlaceOther')"
                    v-model="form.basicInfo.webSite" type="text">
                  </textbox>
                  <CompanyFieldApprovalResults usage-type="companyWebsite" />
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    <TipsAndPrivewDilog :id="'EMPBE_CompanyInfoCenter_ProductCategory_Tips'"
                      :Title="$t('lbl_EMPBE_CompanyInfo_Basic_ProductCategories_Tips')">
                      <template v-slot:Text>
                        {{ $t('lbl_EMPBE_CompanyInfo_Basic_ProductCategories') }}
                        <span style="color: red">*</span>
                      </template>
                    </TipsAndPrivewDilog>
                  </div>
                </div>
                <div class="col-12 form-group" style="gap: 8px;display: grid">
                  <div class="catsecondTitle" v-html="$t('lbl_EMPBE_CompanyInfo_Basic_ProductCategories_Main_Placeother')" >
                  </div>
                 <!--主要选项-->
                   <div v-if="form.tempcompanyCat&&form.tempcompanyCat.length>0" style="">
                   <span v-for="item in companyCatTextList" :key="item.subId">  
                      <div class="selectedCat" >
                      <div class="selectedCatText"  >{{item.text}}</div>
                      <div class="delectSelectedIcon" @click="handleDelete(item,1,true)">
                        <i class="el-icon-close" aria-hidden="true"  ></i>
                      </div>
                      </div>  
                   </span> 
                   </div> 
                    <div v-if="!form.tempcompanyCat||form.tempcompanyCat.length<3" >
                    <b-button id="btnAddCompanyCat" v-model="form.tempcompanyCat" ref="btnAddCompanyCat" class="btn btn-outline-primary p-l-15 d-flex align-items-center" variant="outline-primary"
                     @click="OpenCatalogue(1)" :selectedvalue="form.tempcompanyCat.length" v-bind:t_label="'lbl_EMPBE_ProductInfo_Catalog_AddButtom'">
                    <feather type="plus-circle"> </feather>
                      &nbsp; {{$t('lbl_EMPBE_AddCategory')}}
                   </b-button >
                   <div id="btnAddCat_require" style="display: none; color: #dc3545; padding-left: 6px; padding-top: 2px;">
                    <span v-if="form.tempcompanyCat&&form.tempcompanyCat.length==0"> {{ $t("Lbl_CatName")+ $t("lbl_IsRequire") }}</span>
                     <span v-if="form.tempcompanyCat&&form.tempcompanyCat.length>3"> {{ $t("lbl_maximumchoices").replace('#count#','3')}}</span>
                   </div>
                  </div>
                  <!--子选项-->
                  <div class="catsecondTitle" v-html="$t('lbl_EMPBE_CompanyInfo_Basic_ProductCategories_Other_Placeother')" >
                  </div>

                  <div v-if="form.tempcompanyCat_Sub&&form.tempcompanyCat_Sub.length>0" style=" ">
                   <span v-for="item in companyCatTextList_sub" :key="item.subId" >  
                      <div class="selectedCat" >
                      <div class="selectedCatText" >{{item.text}}</div>
                      <div class="delectSelectedIcon"  @click="handleDelete(item,2,true)">
                        <i class="el-icon-close" aria-hidden="true" style=" "></i>
                      </div>
                      </div>  
                   </span> 
                   </div> 
                    <div v-if="!form.tempcompanyCat_Sub||form.tempcompanyCat_Sub.length<30" >
                    <b-button id="btnAddCompanyCat_sub" v-model="form.tempcompanyCat_sub" :selectedvalue="form.tempcompanyCat_Sub.length" ref="btnAddCompanyCatSub" class="btn btn-outline-primary p-l-15 d-flex align-items-center" variant="outline-primary"
                     @click="OpenCatalogue(2)"  v-bind:t_label="'lbl_EMPBE_ProductInfo_Catalog_AddButtom'">
                    <feather type="plus-circle"> </feather>
                      &nbsp; {{$t('lbl_EMPBE_AddCategory')}}
                   </b-button >
                   <div id="btnAddCat_requireSub" style="display: none; color: #dc3545; padding-left: 6px; padding-top: 2px;">
                    <span v-if="form.tempcompanyCat_Sub&&form.tempcompanyCat_Sub.length==0"> {{ $t("Lbl_CatName")+ $t("lbl_IsRequire") }}</span>
                     <span v-if="form.tempcompanyCat_Sub&&form.tempcompanyCat_Sub.length>30"> {{ $t("lbl_maximumchoices").replace('#count#','30')}}</span>
                   </div>
                  </div>

                 <!-- <div class="form-group form-10-bottom-margin" style="margin-bottom: 10px !important">
                     <multiselection id="companyCategoryListMain" name="companyCategoryListMain"
                      v-model="form.companyCategoryListMain" label="name" track-by="code"
                      :options="SelectOptions.ProductCategoriesOptions" :MaxLength="3" :close-on-select="false"
                      :title="$t('lbl_EMPBE_CompanyInfo_Basic_ProductCategories_Main_Placeother')"
                      :mandatory="$t('lbl_EMPBE_CompanyInfo_Basic_ProductCategories_Main_Placeother') + $t('lbl_IsRequire')">
                    </multiselection> 
                    
                
                  </div>-->
                </div>
                 <!-- <div class="col-12">
                  <div class="form-group form-10-bottom-margin">
                   <multiselection id="companyCategoryListSub" name="companyCategoryListSub"
                      v-model="form.companyCategoryListSub" label="name" track-by="code"
                      :options="SelectOptions.ProductCategoriesOptions" :MaxLength="10" :close-on-select="false"
                      :title="$t('lbl_EMPBE_CompanyInfo_Basic_ProductCategories_Other_Placeother')">
                    </multiselection> 
                  </div>
                </div>-->
              </div>
              <div class="row">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    <TipsAndPrivewDilog :id="'EMPBE_CompanyInfoCenter_ApplicationIndustry_Tips'"
                      :Title="$t('lbl_EMPBE_CompanyInfo_Basic_ApplicationIndustries_Tips')">
                      <template v-slot:Text>
                        {{ $t('lbl_EMPBE_CompanyInfo_Basic_ApplicationIndustries') }}
                        <span style="color: red">*</span>
                      </template>
                    </TipsAndPrivewDilog>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group form-10-bottom-margin" style="margin-bottom: 10px !important">
                    <multiselection v-model="form.companyIndustryListMain" label="name" track-by="code" :MaxLength="5"
                      :options="SelectOptions.IndustriesOptions" :multiple="true" :taggable="true"
                      :mandatory="$t('lbl_EMPBE_CompanyInfo_Basic_ApplicationIndustries_Main_Placeother') + $t('lbl_IsRequire')"
                      :title="$t('lbl_EMPBE_CompanyInfo_Basic_ApplicationIndustries_Main_Placeother')">
                    </multiselection>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group form-10-bottom-margin">
                    <multiselection v-model="form.companyIndustryListSub" label="name" track-by="code" :MaxLength="5"
                      :options="SelectOptions.IndustriesOptions" :multiple="true" :taggable="true"
                      :title="$t('lbl_EMPBE_CompanyInfo_Basic_ApplicationIndustries_Other_Placeother')">
                    </multiselection>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="CenterCard">
            <BasicPageTop :Name="$t('lbl_EMPBE_CompanyInfo_Basic_TradeInformation')">
              <template v-slot:Body>
                <div class="BasicTop-Card" v-html="$t('lbl_EMPBE_CompanyInfo_Basic_TradeInformation_Blue_p',{href:GetTradeInformation})">
                </div>
              </template>
            </BasicPageTop>
            <div>
              <div class="row">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{ $t('lbl_EMPBE_CompanyInfo_Basic_BusinessNature') }} <span class="text-danger">*</span>
                  </div>
                  <div class="Input_Label_Right"><span class="text-danger">*</span>&nbsp;{{
                    $t('lbl_EMPBE_CompanyInfo_Basic_Required')}}</div>
                </div>
                <div class="col-12">
                  <BasicPageNature v-model="form.BusinessNature" :countryOptions="SelectOptions.CountryOptions"
                    :BusinessNatureOptions="SelectOptions.BusinessNatureOptions"> </BasicPageNature>
                  <CompanyFieldApprovalResults usage-type="businessNatureOther" />
                </div>
              </div>
              <div class="row" v-if="AplusABCBooth">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{ $t('lbl_EMPBE_CompanyInfo_Basic_AnnualSalesRevenue') }}
                  </div>
                </div>
                <div class="MoreDivInLine_16 col-12">
                  <div class="MoreDivInLine_Row_5">
                    <selection ContolId="salesCurrency" :title="$t('lbl_EMPBE_CompanyInfo_Basic_Currency')"
                      v-model="form.basicInfo.salesCurrency" label="text" :options="SelectOptions.CurrencyUnitOptions">
                    </selection>
                  </div>
                  <div class="MoreDivInLine_Row_7">
                    <selection ContolId="salesRevenue" :title="$t('lbl_EMPBE_PleaseSelect')"
                      v-model="form.basicInfo.salesRevenue" label="text"
                      :options="SelectOptions.AnnualSalesRevenueOptions">
                    </selection>
                  </div>
                </div>
              </div>
              <!-- 基本展台(Member)可填；仅免费(Guest)隐藏。年销售收入仍用 AplusABCBooth -->
              <div class="row" v-if="AplusABCBasicBooth">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{ $t('lbl_EMPBE_CompanyInfo_Basic_TopTree') }} 
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group form-10-bottom-margin">
                   <multiselection id="TargetMarketsIds" name="TargetMarketsIds"
                      label="label" track-by="id"
                      v-model="form.TargetMarketsIds"  :IsHidenParentCheckbox="true" 
                      :options="SelectOptions.TargetMarketsOptions"  :close-on-select="false"
                      :title="$t('lbl_EMPBE_CompanyInfo_Basic_TopTree')"
                     >
                      <!-- :mandatory="$t('lbl_EMPBE_CompanyInfo_Basic_TopTree') + $t('lbl_IsRequire')" -->
                    </multiselection>
                  </div>
                </div>
                <!-- <div class="MarketRow">
                  <BasicPageToptreeMarkets :MarketOptions="SelectOptions.MarketOptions"
                    :nums="form.companyExportPercentageNums" v-model="form.companyExportPercentageList">
                  </BasicPageToptreeMarkets>
                </div> -->
              </div>
            </div>
          </div>
        </template>
      </PageValidate>
    </b-overlay>
 <!-- 产品类别选择模态框 -->
      <CatsOpupModal v-if="showCategoryModal" id="comp_categorySelectModal" 
      :initSelectItems="categoryInitiSelectItmes" :maxLength="catsMaxLength" :showModal.sync="showCategoryModal"
      :checkListData="SelectOptions.MstCategoriesOptions"
      :companySelectedData="[]" 
      @confirmSelected="fromChird_confirmSelectCats"  
      ></CatsOpupModal>

  </div>

</template>

<script>
import { getAncestorPath, getAncestorIds } from '@/_helpers/treeUtils';
import { AlertDialog } from "@/_helpers/AlertDialog";
import { CompanyInfoService } from "@/_services";
import { LogService } from "../../_services/log.Service";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import BasicPageTop from "./Popup/BasicPageTop.vue"
import BasicPageToptreeMarkets from './Popup/BasicPageToptree_Markets.vue'
import BasicPageNature from './Popup/BasicPageNature.vue'
import CatsOpupModal from "../../components/popup/CatalogueModal.vue";
import {
  brRuntimeState,
  isBrFeatureEnabled,
  loadBrSubmissionStatus,
} from '../../constants/businessRegistration';
import { hasBrVerifiedDocument } from '../businessDocuments/utils/brDocument';
import CompanyFieldApprovalResults from './CompanyFieldApprovalResults.vue';

export default {
  mixins: [AlertDialog],
  components: {
    BasicPageTop, BasicPageNature, BasicPageToptreeMarkets, CatsOpupModal, CompanyFieldApprovalResults,
  },
  inject: {
    permissionData: { default: null },
    companyApprovalHost: { default: null },
  },
  props: {
    supplierId: { default: null },
    SelectOptions: { default: null },
    /** 管理端代看：补公司名下方 BR 提示文案 */
    fromAdmin: { type: Boolean, default: false },
    submitType:{type: String, default: ''},
    openSupplierBusinessDocuments: { default: null },
  },
  data() {
    return {
      loading: false,
      IsCreated:false,
      cdnURL:"https://cdn.adsalecdn.com/EMP/Backend/svg/CompanyInfo/",
      form:
      {
        companyExportPercentageNums: 3,
        basicInfo:
        {
          EmpCompanyId: "",
          nameEng: "",
          nameTrad: "",
          shortNameT: "",
          shortNameE: "",
          establishment: "",
          employee: "",
          officeSpace: "",
          unitOfSpace: "",
          webSite: "",
          isPubliclyListed: false,
          stockExchanges: "",
          stockCode: "",
          totalOffice: "",
          salesRevenue: "",
          salesCurrency: "",
          companyBusinessNature: "",
          companyBusinessNature_Other: "",
          manufacturer_Agents: "",
          isCoExh: false,
          customerType:"",
        },
        BusinessNature: {
          BusinessNatureList: [],
          IsAgents: false,
          CompanyList: [],
          Others: ""
        },
        TargetMarketsOptionss: [],
        tempcompanyCat:[],
        companyCategoryListMain: [],
        companyCategoryListSub: [],
        tempcompanyCat_Sub:[],
        companyIndustryListMain: [],
        companyIndustryListSub: [],
        TargetMarketsIds:[],
        // Top 3 Target Markets and Export Percentage 
        companyExportPercentageList:
          [
            {
              empCompanyID: undefined,
              exportType: "",
              percentageId: ""
            },
            {
              empCompanyID: undefined,
              exportType: "",
              percentageId: ""
            },
            {
              empCompanyID: undefined,
              exportType: "",
              percentageId: ""
            }
          ]
      },
      prodCats:[],
      disabledDates: {
        from: new Date(),
      },
      AdPageName: [
        { type: "bannerAd", name: this.$t('lbl_EMPBE_BannerAd')},
        { type: "logoAd", name: this.$t('lbl_EMPBE_LogoAd')},
        { type: "buttonAd", name: this.$t('lbl_EMPBE_ButtonAd')},
        { type: "landingAd", name: this.$t('lbl_EMPBE_LandingPageAd')},
        { type: "videoAd", name: this.$t('lbl_EMPBE_VideoAd')},
        { type: "starAd", name: this.$t('lbl_EMPBE_StarAd')},
        { type: "catListAd", name: this.$t('lbl_EMPBE_CatListAd')},
        { type: "priorityAd", name: this.$t('lbl_EMPBE_priorityAds')},
      ],
      dirty: null,
      IsCateDuplicated: false, // use for dead loop bug fix [SJP]
      IsIndustryDuplicated: false,// use for dead loop bug fix [SJP]
      ApprovedSubDomain : "" //use for listen shortname changes [SJP]
      ,
      showCategoryModal:false,
      categoryInitiSelectItmes: [], // 保存初始 
      currentTypeStatus: 1, // 当前打开的类型：1 主要类型�?其他类型
      catsMaxLength:1,      
      deleteStatus:0,
      originalProductIndustrysMain:[],
      originalProductIndustrysSub:[],
      isDuplicateIndustryMain:false,//记录移除重复记录，
      isDuplicateIndustrySub:false,//记录移除重复记录，
      AdCheckItems:[],
    };
  },
  watch: {
    supplierId: {
      handler() {
        this.InitData();
      },
      deep: true,
    },
    form: {
      handler() {
        if(!this.IsCreated)
        {
          this.dirty = true;
          this.$store.state.dirty = this.dirty;
        }
      },
      deep: true,
    },
    // 'form.companyCategoryListMain': {
    //   async handler(value, oldValue) {
    //     if(!this.IsCreated) {
    //       var IsCheck = await this.CheckHasAd('cat',value,oldValue);
    //       if(IsCheck && oldValue.length > value.length)
    //       {
    //         this.form.companyCategoryListMain = oldValue;
    //       }
    //     }
    //   },
    //   deep: true
    // },
    // 'form.companyCategoryListSub': {
    //   async handler(value, oldValue) {
    //     if(!this.IsCreated){
    //       var IsCheck = await this.CheckHasAd('cat',value,oldValue);
    //       if(IsCheck && oldValue.length > value.length)
    //       {
    //         this.form.companyCategoryListSub = oldValue;
    //       }
    //     }

    //   },
    //   deep: true
    // },
    'form.companyIndustryListMain': {
      // async handler(value, oldValue) {
      //   if(!this.IsCreated) {
      //     var IsCheck = await this.CheckHasAd('app',value,oldValue);
      //     if(IsCheck && oldValue.length > value.length)
      //     {
      //       this.form.companyIndustryListMain = oldValue;
      //     }
      //   }
      // },
      // deep: true
          async handler(newVal, oldValue) { 
             if(this.isDuplicateIndustryMain==true) {
            this.isDuplicateIndustryMain=false;
            return;  
            }
          if(!this.IsCreated)
          {
            if(oldValue.length > newVal.length){
             var removeItemId= oldValue.find(a => !newVal.includes(a));
              let node={
                id:removeItemId
              } 
              
             var IsCheck = await  this.removeApps(node,1); 
             if(IsCheck==false&& oldValue.length > newVal.length){ 
              this.form.companyIndustryListMain = [...oldValue]
             }
            }
          }
          if(oldValue.length < newVal.length){ //新增 判断 主 次 是否有重复选择         
            var checkId= newVal.find(a => !oldValue.includes(a));      
            let subIndustry=this.form.companyIndustryListSub; 
            let idx=subIndustry.findIndex(a=>a.toString()==checkId.toString());
            if(idx!=-1)
            {
              this.isDuplicateIndustrySub=true;
              this.form.companyIndustryListSub.splice(idx, 1); 
            }
          }
          
       }
    },
    'form.companyIndustryListSub': {
      // async handler(value, oldValue) {
      //   if(!this.IsCreated) {
      //     var IsCheck = await this.CheckHasAd('app',value,oldValue);
      //     if(IsCheck && oldValue.length > value.length)
      //     {
      //       this.form.companyIndustryListSub = oldValue;
      //     }
      //   }
      // },
      // deep: true
      
       async handler(newVal, oldValue) { 
        if(this.isDuplicateIndustrySub==true) {
        this.isDuplicateIndustrySub=false;
        return;  
        }
          
          if(!this.IsCreated)
          {
            if(oldValue.length > newVal.length){
             var removeItemId= oldValue.find(a => !newVal.includes(a));
              let node={
                id:removeItemId
              }  
             var IsCheck = await  this.removeApps(node,2); 
             if(IsCheck==false&& oldValue.length > newVal.length){ 
              this.form.companyIndustryListSub = [...oldValue]
             }
            }
          }

          if(oldValue.length < newVal.length){ //新增 判断 主 次 是否有重复选择   
            var checkId= newVal.find(a => !oldValue.includes(a));      
            let mainIndustry=this.form.companyIndustryListMain; 
            let idx=mainIndustry.findIndex(a=>a.toString()==checkId.toString());
            if(idx!=-1)
            {
              this.isDuplicateIndustryMain=true;
              this.form.companyIndustryListMain.splice(idx, 1); 
            }
          }
       }
    },

  },
  computed: {
    useFormalTables() {
      const host = this.companyApprovalHost;
      return !!(host && host.fromAdmin && host.isApprovalMode);
    },
    GetTradeInformation(){
      return this.GetEboothView();
    },  
    GetBasicInformation(){
      return this.GetEboothView();
    },  
    GetTotalNumber(){
      return this.form.basicInfo.unitOfSpace == "5" ? this.SelectOptions.OfficeQtyOptionsBySpaceFoot : this.SelectOptions.OfficeQtyOptionsBySpaceMaster;
    },
    GetWebSites(){
      //审批后返回审批后的内�?
      if(this.form.basicInfo.subDomainStatusCode == 'A' ) return this.ApprovedSubDomain;
      var website = this.form.basicInfo.shortNameE.toLowerCase().replace(/[^\w\s]/g, ' ').replace(/\s+/g,'-').replace(/([!\"#$%&'()*+,-./:;<=>?@[\\\]^_{|}~])\1+/g, '$1')
                    || this.$t('lbl_EMPBE_Empty_BrandedURL')
      if(website.length>0)
      {
        if(website[0]==="-"){
          website = website.substring(1);
        }
        if(website[website.length-1]==="-"){
          website = website.substring(0,website.length-1);
        }
      }
      return website;
    },
    isShowNoandGuest() {
      return this.permissionData ? (this.permissionData["Type"] != "") : false;
    },
    langid() {
      return localStorage.getItem("currentLangId");
    },
    user() {
      return this.$store.state.authentication.user;
    },
    AplusABCBooth() {
      if (this.permissionData) {
        return ["A+","A", "B", "C"].includes(this.permissionData["Type"]);
      } else {
        return false;
      }
    },
    AplusABCBasicBooth() {
      if (this.permissionData) {
        return ["A+","A", "B", "C","Member"].includes(this.permissionData["Type"]);
      } else {
        return false;
      }
    },
    isCompanyShortNameDirty(){
      return this.ApprovedSubDomain != this.GetWebSites
    },
  
     companyCatTextList(){//类型，是主要的、还是其他产品类�?1 主要类型�?其他类型 
      if(this.SelectOptions.MstCategoriesOptions.length>0){
      var tempDataList=this.form.tempcompanyCat;
      if(tempDataList&&tempDataList.length>0)
        {           
        let textList=tempDataList.map(item=>({
        subId: item.subId.toString(),
        text:this.SelectOptions.MstCategoriesOptions.find(x => x.id.toString()== item.subId.toString()).text,
        order:item.orderId,
        mainId:item.mainId
        })).sort((a, b) => {
              return parseInt(a.order) - parseInt(b.order);
            }); 
            return textList; 
        }
      }
        return [];
    },
    // 关 BR → 无提示不锁；有生效 BR（供应商）/ 管理端开 BR → 提示+锁定（与供应商一致）
    showCompanyNameBrHint() {
      if (!isBrFeatureEnabled()) return false;
      if (this.fromAdmin) return true;
      return hasBrVerifiedDocument(brRuntimeState.documentList || []);
    },
    isCompanyNameFieldDisabled() {
      return !!this.form.basicInfo.isCoExh
        || this.showCompanyNameBrHint;
    },
     companyCatTextList_sub(){//类型，是主要的、还是其他产品类�?1 主要类型�?其他类型
      // console.log('companyCatTextList-sub')
       if(this.SelectOptions.MstCategoriesOptions.length>0){
      var tempDataList=this.form.tempcompanyCat_Sub;//过滤重复    ///this.form.companyCategoryListMain 
      if(tempDataList&&tempDataList.length>0)
        {          
       let textList=tempDataList.map(item=>({
       subId: item.subId.toString(),
       text:this.SelectOptions.MstCategoriesOptions.find(x => x.id.toString()== item.subId.toString()).text,
       order:item.order,
       mainId:item.mainId
        }))
        .sort((a, b) => {
            return parseInt(a.order) - parseInt(b.order);
          }); 
           return textList;
        }
      }
       return [];
    }
  },
  mounted() {
    this.InitData();
    if (!this.fromAdmin && isBrFeatureEnabled()) {
      loadBrSubmissionStatus(false);
    }
  },
  methods: {
    GetProductCatList() {
      CompanyInfoService.GetProductCatList().then((response) => {
        this.prodCats = response.data;
      });
    },
    async GetProdUpCats(id) {
      var result2 = await getAncestorPath(this.prodCats, id);
      return result2.length > 0 ? result2 : [];
    },
    async getAncestorIds(id) {
      var result2 = await getAncestorIds(this.prodCats, id);
      return result2.length > 0 ? result2 : [];
    },
    async CheckHasAd(type,newVal,oldVal){

        //获取被删的id
        var CheckIds = oldVal.filter(item=>!newVal.includes(item))
        //var data =await this.GetProductAndAdCheckItem();
        var CheckOptions =  this.AdCheckItems.filter(item=>item.type == type && CheckIds.includes(item.id+''))
        
        if(CheckOptions.length>0)
        {
          var adName = '';
          var currentItem = '';
          var correspondenceItem = '';
          var adNameTips='';
          var productNameTips='';
          //获取是否有广�?
          var adNames = CheckOptions.filter(item=> item.isAd)
            .map(a => this.AdPageName.filter(b => b.type == a.name)
            .map(c => c.name))
            .flat();
          adName = adNames.join(",");
          var nonAdOptions = CheckOptions.filter(item => !item.isAd);
          currentItem = [...new Set(nonAdOptions.map(item => item.name))].join(",");
          correspondenceItem = [...new Set(CheckOptions.map(item => item.text))].join(",");
          

          if(adName.length>0) adNameTips = this.$t('lbl_EMPBE_CompanyInfoCheckItems_AdName',{adnames:adName});
          if(currentItem.length>0) productNameTips = this.$t('lbl_EMPBE_CompanyInfoCheckItems_ProductName',{productName:currentItem});
          var Tips = '';
          if(type==='app')
          {
              Tips = this.$t('lbl_EMPBE_CompanyInfoCheckItems_App',{
              names: correspondenceItem,
              adnames: adNameTips,
              productName: productNameTips
            });
          }
          else
          {
            Tips = this.$t('lbl_EMPBE_CompanyInfoCheckItems_Cat',{
              names: correspondenceItem,
              adnames: adNameTips,
              productName: productNameTips
            });
          }

            //提示�?
            this.showConfirm_Img(
              '',
              Tips,
              this.$t('lbl_EMPBE_Confirm'),
              "",
              "",
              "",
              50,
              50,
              "AlertDialog-Ad-SaveSucess",
              true,
              "",
              "",
              "",
              false,
              false,
              true,
              false
            )
            return true;
        }
        else
        {
          return false;
        }
    },

    async removeApps(item,appType){
        // 公司删应用行业不会同步删产品 → 仅产品关联时不弹窗；仅广告关联仍提醒
        const originalData =appType==1?this.originalProductIndustrysMain :appType==2?this.originalProductIndustrysSub:[];
      var hasSaveIdObj =originalData.find(a=>a.industryId.toString() == item.id.toString());
        
    if(hasSaveIdObj)
      {
        var CheckId=hasSaveIdObj.industryId.toString();
        var chekcedList= this.AdCheckItems.filter(item=>item.type == 'app' && CheckId==item.id.toString())
          if(chekcedList.length>0){
            var adNamesList = chekcedList.filter(a =>a.isAd).map(a=>this.AdPageName.filter(b => b.type == a.name).map(c => c.name))
            .flat();
          var AdNames = [...new Set(adNamesList)].join(",");

          // 无广告关联：直接允许删除（产品关联不再弹「同步删产品」提醒）
          if(adNamesList.length === 0) {
            return true;
          }

          var lblAdname = this.$t('Lbl_Advertisement');
          var tipHtml = `<ul class='ItemUL' ><li >${lblAdname}: <span style='font-weight: 400; '>${AdNames}</span> </li></ul>`;
          var indOpt = this.SelectOptions.IndustriesOptions.find(a=>a.id.toString()==item.id.toString());
          var lblCatName = indOpt ? indOpt.label : '';

          return new Promise((resolve) => {
            this.ConfirmCustomHtml(
              this.$t('lbl_EMPBE_DeleteCategory_Title',{CatName:lblCatName}),
              this.$t('lbl_EMPBE_DeleteCategory_body',{AdOrproText:tipHtml}),
              this.$t('lbl_EMPBE_Delete'),
              this.$t('lbl_EMPBE_ProductInfo_Delete_Cancel')
            ).then((res) => {
              resolve(!!res.isConfirmed);
            });
          });
          } else{
            return true;
            }
      }else{
        return true;
      }
    },

    async handleDelete(item,catType,isTrueDelete){//catType 1：主要类型�?：其他类�?isTrueDelete:是否是真删除，如果是修改的时候，做假删除
    if(isTrueDelete==undefined||isTrueDelete==null) isTrueDelete=true;

    const catTypeStatus=catType?catType:this.currentTypeStatus;
    const isConfirmed = await this.removeCats(item,catTypeStatus);
      if(isConfirmed==true&&isTrueDelete) 
      {
        let node={subId:item.subId}
        this.delSelectCats(node,catTypeStatus); 
      }
      return isConfirmed;
    },
    async GetAdItemList(id){
      var res = await this.GetProdUpCats(id);
      var data = this.AdCheckItems.filter(item=>item.type == 'cat' && res.includes(item.id.toString()));
      return data;
    },
    async GetAdRepeatCount(id,CheckUpId){
      // 规则：先按 level2（CheckUpId）判断；若 level2 下原本只有当前这一个，则回退按 level1 判断

      const treeForCats =
        (this.SelectOptions &&
          this.SelectOptions.ProductCategoriesOptions &&
          Array.isArray(this.SelectOptions.ProductCategoriesOptions) &&
          this.SelectOptions.ProductCategoriesOptions.length > 0)
          ? this.SelectOptions.ProductCategoriesOptions
          : this.prodCats;

      const allSelected = [
        ...(this.companyCatTextList || []),
        ...(this.companyCatTextList_sub || [])
      ];
      const remainingSelected = allSelected.filter(x => String(x.subId) !== String(id));

      // 判断一个选项是否“属于某个上级Id(UpId)”
      const isUnderUpId = (x, upId) => {
        if (upId == null) return false;
        if (String(x.subId) === String(upId)) return true;
        if (String(x.mainId) === String(upId)) return true;
        const ancestors = getAncestorIds(treeForCats, x.subId);
        return !!(ancestors && ancestors.some(a => String(a) === String(upId)));
      };

      // 当前被删项的 level1（root）
      const currentAncestors = getAncestorIds(treeForCats, id); // 只取上级，不含自身
      const level1 = (currentAncestors && currentAncestors.length > 0) ? currentAncestors[0] : null;

      // level2 判断：若 level2 下原本有多个，则只有删到最后一个才返回 true
      if (CheckUpId != null) {
        const countBefore = allSelected.filter(x => isUnderUpId(x, CheckUpId)).length;
        const countAfter = remainingSelected.filter(x => isUnderUpId(x, CheckUpId)).length;

        if (countBefore > 1) {
          const result = countAfter === 0;
          return result;
        }
      } else {
        // 没有 level2，上来就回退 level1
      }

      // level1 回退：只要 level1 下还有其他项，就不是最后一个
      if (!level1) {
        return true;
      }

      const level1CountAfter = remainingSelected.filter(x => isUnderUpId(x, level1)).length;
      const result = level1CountAfter === 0;
      return result;
    },
    async removeCats(item,catType){//catType 1：主要类型 2：其他类型
       // 公司删产品类别不会同步删产品 → 仅产品关联时不弹窗；仅广告关联仍提醒
      const originalData =catType==1?[...this.form.companyCategoryListMain || []]:catType==2?[...this.form.companyCategoryListSub || []]:[];
      var hasSaveIds= originalData.find(a=>a.toString() == item.subId.toString());
       
    if(hasSaveIds&&hasSaveIds.length>0)
      {
        var CheckId=item.subId;
        var CheckUpId=item.mainId;
        var chekcedList= await this.GetAdItemList(CheckId);          
          if(chekcedList.length>0){
           const adItems = chekcedList.filter(a => a.isAd);
           const isLastOneUnderParent = await this.GetAdRepeatCount(CheckId,CheckUpId);

           // 只有“删除的这个分类在其父级下是最后一个”时，才展示广告提示
           var adNamesList = isLastOneUnderParent
            ? adItems.map(a => this.AdPageName.filter(b => b.type == a.name).map(c => c.name)).flat()
            : [];

          var AdNames = [...new Set(adNamesList)].join(",");

           // 无广告需提示：直接允许删除（产品关联不再弹「同步删产品」提醒）
           if (adNamesList.length === 0) {
             return true;
           }

           var lblAdname = this.$t('Lbl_Advertisement');
           var tipHtml = `<ul class='ItemUL' ><li >${lblAdname}: <span style='font-weight: 400; '>${AdNames}</span> </li></ul>`;
          return new Promise((resolve) => { 
            this.ConfirmCustomHtml(
            this.$t('lbl_EMPBE_DeleteCategory_Title',{CatName:item.text}),
            this.$t('lbl_EMPBE_DeleteCategory_body',{AdOrproText:tipHtml}),
            this.$t('lbl_EMPBE_Delete'),
            this.$t('lbl_EMPBE_ProductInfo_Delete_Cancel')
          ).then((res) => {
                 resolve(!!res.isConfirmed);
              });
          });
            
          } else{
            return true;
          }
      }else{
        return true;
      }
    },
        //多�?删除选择事件
    delSelectCats(node,catType) {
      let TempExhibitCats =catType==1? this.form.tempcompanyCat:this.form.tempcompanyCat_Sub;
      let index = TempExhibitCats.findIndex(a => a.subId.toString() === node.subId.toString());
      if (index !== -1) {
        TempExhibitCats.splice(index, 1); 
       }
       if(catType==1){
        this.form.tempcompanyCat = TempExhibitCats;
       }  else if (catType==2){
      this.form.tempcompanyCat_Sub = TempExhibitCats;
      }
    },
    async GetProductAndAdCheckItem(){
       // var data =[];
        await CompanyInfoService.GetProductAndAdCheckItem({CompId:this.supplierId,langId:this.langid}).then((response) => {
          if (response.isSuccessful) {
            this.AdCheckItems = response.data;
          }
        });
       // return data;
    },
    InitData() {
      this.GetProductCatList();
      this.GetData();
      this.GetProductAndAdCheckItem();//查询广告和非广告品类和引用行业的关联
      this.resetFormVerify();
      setTimeout(() => {
        this.dirty = false;
        this.$store.state.dirty = this.dirty;
      }, 200);
    },
    GetData() {
      this.loading = true;
      this.IsCreated=true;
      CompanyInfoService.GetCompanyProfile(this.supplierId, this.useFormalTables).then(res => {
        if (res.isSuccessful) {
            var result = res.data;
            this.form.basicInfo = result.basicInfo ?? this.form.basicInfo;
            this.form.BusinessNature.BusinessNatureList = this.form.basicInfo.companyBusinessNature.length > 0 ? (this.form.basicInfo.companyBusinessNature.split(",").map(item => item.toString())) : [];
            this.form.BusinessNature.IsAgents = this.form.basicInfo.manufacturer_Agents.toLocaleLowerCase() == "false" ? false : true;
            this.form.BusinessNature.CompanyList = this.form.BusinessNature.IsAgents ? (this.form.basicInfo.manufacturer_Agents.length > 0 ? (this.form.basicInfo.manufacturer_Agents.split(",")) : []) : [];
            this.form.BusinessNature.Others = this.form.basicInfo.companyBusinessNature_Other;
            this.form.companyCategoryListMain = result.companyCategoryListMain.map(item => item.subId.toString());

            this.form.tempcompanyCat=result.companyCategoryListMain;
            this.form.companyCategoryListSub = result.companyCategoryListSub.map(item => item.subId.toString()).filter(item=>!this.form.companyCategoryListMain.includes(item.toString()));
            this.form.tempcompanyCat_Sub=result.companyCategoryListSub.filter(item=>!this.form.companyCategoryListMain.includes(item.subId.toString()));;

            this.form.companyIndustryListMain = result.companyIndustryListMain.map(item => item.industryId.toString());
            this.originalProductIndustrysMain=Array.isArray(result.companyIndustryListMain)? JSON.parse(JSON.stringify(result.companyIndustryListMain)) 
            : [];

            this.form.companyIndustryListSub = result.companyIndustryListSub.map(item => item.industryId.toString()).filter(item=>!this.form.companyIndustryListMain.includes(item));

            let industriesSubNotContainMain= result.companyIndustryListSub.filter(item=>!this.form.companyIndustryListMain.includes(item.industryId))

            this.originalProductIndustrysSub= Array.isArray(industriesSubNotContainMain) ? JSON.parse(JSON.stringify(industriesSubNotContainMain)) 
            : [];
            
            const exportMarketIds = String(result.basicInfo?.exportMarketIds ?? "")
              .split(",")
              .map(item => String(item).trim())
              .filter(item => item !== "" && item !== "0");
            this.form.TargetMarketsIds = exportMarketIds;
            this.ApprovedSubDomain = result?.basicInfo?.approvedSubDomain.toLowerCase();
            result.companyExportPercentageList.forEach((item, index) => {
            this.form.companyExportPercentageList[index].supplierId = this.supplierId;
            this.form.companyExportPercentageList[index].exportType = item.exportType;
            this.form.companyExportPercentageList[index].percentageId = item.percentageId==0?"":item.percentageId;
            });
        }
        setTimeout(() => {
          this.IsCreated = false;
        }, 500);
      }).catch((err) => {
        console.error(err);
      }).finally(() => {
        this.loading = false;
      });
    },
    GetEboothView(){
        var  Companies = [];
        if(this.permissionData && this.permissionData?.Type != "Guest")
        {
          Companies = this.SelectOptions.EboothSample.filter(company => company.Grade === this.permissionData["Type"]);
        }
        else//Free
        {
          //
          Companies =  this.SelectOptions.EboothSample.filter(company => company.Grade === "Free");
        }
        const randomIndex = Math.floor(Math.random() * Companies.length);
        const randomCompany = Companies[randomIndex];

        return  randomCompany?.companyUrl;
    },
    //重置表单验证
    resetFormVerify() {
      this.$refs.basicInfoObserver.reset();
    },
    async CheckCatalogAndIndustrys() {
      var that = this;
      try {
        var CheckCatalogAndIndustrys = await CompanyInfoService.CheckCatalogAndIndustrys({
          companyid: that.supplierId,
          langid: that.langid
        }).then((response) => {
          if (response.isSuccessful) {
            var createBy = that.user.empCompanyId;
            var Product_SubId = response.data.product_SubId;
            var Product_IndustryId = response.data.product_IndustryId;
            var ProductList = response.data.productList;

            var options_productCats = JSON.parse(
              JSON.stringify(that.SelectOptions.ProductCategoriesOptions))
            var options_applicationIndustries = JSON.parse(
              JSON.stringify(that.SelectOptions.IndustriesOptions))

            //Get all third level category data
            const CatWithChildren = options_productCats.filter(x => x.children);
            const AllSecondLevelCats = CatWithChildren.map(x => x.children).flat();
            //Some Second level cat don't have children, need to explicitly include in concact clause 
            const AllThirdLevelCats = AllSecondLevelCats.filter(x => x.children).map(x => x.children).flat().concat(
              AllSecondLevelCats.filter(x => !x.children)
            ).concat(options_productCats.filter(x => !x.children) //Other
            )

            var companyCategoryListMain = [];
            var companyCategoryListSub = [];
            var companyIndustryListMain = [];
            var companyIndustryListSub = [];
            var IndustryObj = null;

            if (that.form.companyCategoryListMain.length > 0) {
              for (let i = 0; i < that.form.companyCategoryListMain.length; i++) {
                var cat = this.findChildrenById(that.form.companyCategoryListMain[i], this.SelectOptions.ProductCategoriesOptions)
                var obj = {
                  EmpCompanyId: that.supplierId,
                  SubId: cat["id"],
                  MainId: cat["parent"],
                  OrderId: i + 1,
                }
                companyCategoryListMain[i] = obj;
              }
            }
            if (that.form.companyCategoryListSub.length > 0) {
              for (let i = 0; i < that.form.companyCategoryListSub.length; i++) {
                var cat = this.findChildrenById(that.form.companyCategoryListSub[i], this.SelectOptions.ProductCategoriesOptions)
                var obj = {
                  EmpCompanyId: that.supplierId,
                  SubId: cat["id"],
                  MainId: cat["parent"],
                  OrderId: i + 1,
                }
                companyCategoryListSub[i] = obj;
              }
            }
            if (that.form.companyIndustryListMain.length > 0) {
              for (let i = 0; i < that.form.companyIndustryListMain.length; i++) {
                IndustryObj = new Object();
                IndustryObj.EmpCompanyId = that.supplierId;
                IndustryObj.IndustryId = that.form.companyIndustryListMain[i];
                IndustryObj.CreatedBy = createBy;
                IndustryObj.UpdatedBy = createBy;
                companyIndustryListMain[i] = IndustryObj;
              }
            }
            if (that.form.companyIndustryListSub.length > 0) {
              for (let i = 0; i < that.form.companyIndustryListSub.length; i++) {
                IndustryObj = new Object();
                IndustryObj.EmpCompanyId = that.supplierId;
                IndustryObj.IndustryId = that.form.companyIndustryListSub[i];
                IndustryObj.CreatedBy = createBy;
                IndustryObj.UpdatedBy = createBy;
                companyIndustryListSub[i] = IndustryObj;
              }
            }
            const setCategoryList = new Set([
              ...companyCategoryListMain,
              ...companyCategoryListSub,
            ]);
            const CategoryList = Array.from(setCategoryList);

            const CategoryListSub = Product_SubId.filter(
              (a) => !CategoryList.some((b) => a.toString() === b.SubId.toString())
            );

            const setIndustryList = new Set([
              ...companyIndustryListMain,
              ...companyIndustryListSub,
            ]);
            const IndustryList = Array.from(setIndustryList);

            const IndustryListSub = Product_IndustryId.filter(
              (a) => !IndustryList.some((b) => a.toString() === b.IndustryId.toString())
            );


            if (CategoryListSub.length > 0 || IndustryListSub.length > 0) {
              //If have cat/app selected by product

              var textStr = "";
              textStr = textStr + "<ul style='text-align: left;padding-top:20px'>";
              if (CategoryListSub.length > 0) {
                textStr =
                  textStr +
                  '<li><span style="color:red;">' +
                  that.$t("lbl_EMPBE_ProductCatWarning") +
                  "</span></li>";


                let CollisionName = AllThirdLevelCats.filter(x => CategoryListSub.includes(parseInt(x.id)))
                CollisionName.forEach(x => {
                  //[20240205][JWS] Add product cat
                  textStr += '<li>';
                  textStr += that.$t("Lbl_ProductCategory") + ": ";
                  textStr += CollisionName.map(x => x.label);
                  textStr += '</li>';
                  //[20240131][JWS] Add product name
                  textStr += '<li>';
                  textStr += that.$t("Lbl_EMPBE_CatAlert_ProductName") + ": ";
                  var productArr = ProductList.filter(p => x.id == p.catId);
                  var unique = productArr.filter((a, i) => productArr.findIndex((s) => a.productId === s.productId) === i)
                  for (var i = 0; i < unique.length; i++) {
                    if (i > 0) {
                      textStr += ', ';
                    }
                    textStr += unique[i].exhibitName;
                  }
                  textStr += '</li>';
                })

              }
              if (IndustryListSub.length > 0) {
                textStr =
                  textStr +
                  '<li> <span style="color:red;">' +
                  that.$t("lbl_EMPBE_ApplicationWarning") +
                  "</span></li>";
                IndustryListSub.forEach((item) => {
                  var data = options_applicationIndustries.filter((c) => c.id == item);
                  //[20240205][JWS] Add application industries name
                  textStr += "<li>";
                  textStr += that.$t('lbl_ApplicationIndustries') + ": ";
                  textStr += data[0].label;
                  textStr += "</li>";
                  //[20240205][JWS] Add product name
                  textStr += "<li>";
                  textStr += that.$t("Lbl_EMPBE_CatAlert_ProductName") + ": ";
                  var productArr = ProductList.filter(p => item == p.appId);
                  var unique = productArr.filter((a, i) => productArr.findIndex((s) => a.productId === s.productId) === i)
                  for (var i = 0; i < unique.length; i++) {
                    if (i > 0) {
                      textStr += ', ';
                    }
                    textStr += unique[i].exhibitName;
                  }
                  textStr += "</li>";
                });
              }

              textStr = textStr + "</ul>";
              that.$swal({
                html: textStr,
                showCancelButton: false,
                confirmButtonText: that.$t("lbl_EMPBE_Confirm"),
                cancelButtonText: that.$t("lbl_EMPBE_Cancel"),
              });
              return false;
            } else {
              return true;
            }
          } else {
            return false;
          }
        });
        return CheckCatalogAndIndustrys;
      }
      catch (error) {
        return error
      }
    },
    //向下查找当前id的object
    findChildrenById(id, tree) {
      for (let node of tree) {
        if (node.id === id) {
          return node;
        }
        if (node.children && node.children.length > 0) {
          const result = this.findChildrenById(id, node.children);
          if (result) {
            return result;
          }
        }
      }
      return null;
    },
    CheckCatAppDuplicate(SelectionId, IsCat) {
      const IsNotDuplicated = this.MainSubValidation(SelectionId)
      if (!IsCat && this.IsIndustryDuplicated) {
        this.IsIndustryDuplicated = false
        return true
      }
      if (IsCat && this.IsCateDuplicated) {
        this.IsCateDuplicated = false
        return true
      }

      if (!IsNotDuplicated) {
        this.IsCateDuplicated = IsCat ? true : this.IsCateDuplicated;
        this.IsIndustryDuplicated = !IsCat ? true : this.IsIndustryDuplicated;
        return false
      }

      return false

    },
    //检测主次是否存在有同一个的情况 有的话则将重复选的内容过掉
    MainSubValidation(id) {
      var that = this;

      var SameCat = that.form.companyCategoryListMain.filter(function (item) {
        return (that.form.companyCategoryListSub.filter(sub => sub == item).length > 0)
      })
      var SameApp = that.form.companyIndustryListMain.filter(function (item) {
        return (that.form.companyIndustryListSub.filter(sub => sub == item).length > 0)
      })

      if (SameCat.length > 0 || SameApp.length > 0) {
        switch (id) {
          //if dupplicated , exchange main to sub or sub to main [01032024][SJP]
          case 'companyCategoryListMain':
            //[01032024][SJP] change logic to:when is main, revert sub to original state, vice versa. Then continue proceed to add the selection
            //With this way ,"exchange" can be achieved
            that.form.companyCategoryListSub = that.form.companyCategoryListSub.filter(function (item) {
              if (item != 0) {
                return (that.form.companyCategoryListMain.filter(sub => sub == item).length == 0)
              }
            })
            break;
          case 'companyCategoryListSub':
            that.form.companyCategoryListMain = that.form.companyCategoryListMain.filter(function (item) {
              if (item != 0) {
                return (that.form.companyCategoryListSub.filter(sub => sub == item).length == 0)
              }
            })
            break;
          case 'companyIndustryListMain':
            that.form.companyIndustryListSub = that.form.companyIndustryListSub.filter(function (item) {
              if (item != 0) {
                return (that.form.companyIndustryListMain.filter(sub => sub == item).length == 0)
              }
            })
            break;
          case 'companyIndustryListSub':
            that.form.companyIndustryListMain = that.form.companyIndustryListMain.filter(function (item) {
              if (item != 0) {
                return (that.form.companyIndustryListSub.filter(sub => sub == item).length == 0)
              }
            })
            break;
        }
      }
      if (SameCat.length > 0) {
        return false;
      }
      if (SameApp.length > 0) {
        return false;
      }
      return true;
    },
    //整理結果提交save
    async AfterSaveResult() {
        var data =
        {
          BasicInfo: {},
          CompanyCategoryListMain: [],
          CompanyCategoryListSub: [],
          CompanyIndustryListMain: [],
          CompanyIndustryListSub: [],
          CompanyExportPercentageList: [],
          VaildError:[], //验证失败的filed
          validationErrorLog:"" //验证的errorlog
        }
        data.BasicInfo = this.form.basicInfo;
        data.BasicInfo.exportMarketIds = this.form.TargetMarketsIds.join(",");
        data.BasicInfo.empCompanyID=this.supplierId;
        data.BasicInfo.companyBusinessNature = this.form.BusinessNature.BusinessNatureList.join(",");
        data.BasicInfo.manufacturer_Agents = this.form.BusinessNature.IsAgents ? this.form.BusinessNature.CompanyList.toString() : "false";
        data.BasicInfo.companyBusinessNature_Other = this.form.BusinessNature.Others;
        // this.form.companyCategoryListMain.forEach(item => {
        //   var obj = this.findChildrenById(item, this.SelectOptions.ProductCategoriesOptions);
        //     data.CompanyCategoryListMain.push({
        //     EmpCompanyId: this.supplierId,
        //     SubId: obj.id,
        //     MainId: obj.parent,
        //     OrderId: data.CompanyCategoryListMain.length
        //   })
        // }) 
         data.CompanyCategoryListMain=this.form.tempcompanyCat.map(item=>({
         EmpCompanyId: this.supplierId,
         SubId: item.subId,
         MainId: item.mainId,
         OrderId: item.orderId
         }));

        // this.form.companyCategoryListSub.forEach(item => {
        //   var obj = this.findChildrenById(item, this.SelectOptions.ProductCategoriesOptions);
        //   data.CompanyCategoryListSub.push({
        //     EmpCompanyId: this.supplierId,
        //     SubId: obj.id,
        //     MainId: obj.parent,
        //     OrderId: data.CompanyCategoryListSub.length
        //   })
        // }) 
        data.CompanyCategoryListSub=this.form.tempcompanyCat_Sub.map(item=>({
         EmpCompanyId: this.supplierId,
         SubId: item.subId,
         MainId: item.mainId,
         OrderId: item.orderId
         }));

        this.form.companyIndustryListMain.forEach(item => {
          var obj = this.findChildrenById(item, this.SelectOptions.IndustriesOptions);
          data.CompanyIndustryListMain.push({
            EmpCompanyId: this.supplierId,
            IndustryId: obj.id,
            OrderId: data.CompanyIndustryListMain.length
          })
        })

        this.form.companyIndustryListSub.forEach(item => {
          var obj = this.findChildrenById(item, this.SelectOptions.IndustriesOptions);
          data.CompanyIndustryListSub.push({
            EmpCompanyId: this.supplierId,
            IndustryId: obj.id,
            OrderId: data.CompanyIndustryListSub.length
          })
        })

        this.form.companyExportPercentageList.forEach(async item => {
          var list = data.CompanyExportPercentageList.map(a=>a.ExportType);
          var Type=item.exportType;
          if(!Type)
          {
            Type = this.SelectOptions.MarketOptions.filter(a=>!list.includes(a.id))[0].id;
          }

          data.CompanyExportPercentageList.push({
            EmpCompanyId: this.supplierId,
            ExportType: Type,
            PercentageId: item.percentageId
          })
        })

      return data;

    },

    LogPageFormError(errorLogObj, action) {
      LogService.LogFormErrorWithObj({
        EmpCompanyId: this.supplierId,
        PageName: this.$route.path.split("/")[1],
        SectionName: "BasicInfo",
        Action: action,
      }, errorLogObj);
    },

    //保存
    async Save() {
      var data = await this.AfterSaveResult();
      //写日志
      const query = {
        FormId: this.supplierId,
        Action: 'Before_Save',
        FormType: 'Company_BasicInfo',
        ErrorLog: data.validationErrorLog
      };
      LogService.LogFormDataWithObj(query, data);

      this.$submitFormMessage.ShowProgressWithoutUploadPopup({ isSubmit: false });

      return new Promise((resolve, reject) => {
        CompanyInfoService.SaveCompanyProfile(data).then(res => {
          if (res.isSuccessful) {
            this.InitData();

            resolve({
              isSuccessful: true,
              popupAlertMsg: this.$t("lbl_EMPBE_SubmitAlert_SaveSuccessMessage"),
            });
          } else {
            this.LogPageFormError({ res: res }, "Save_SaveCompanyProfile");

            reject({
              isSuccessful: false,
              popupAlertMsg: this.$t("lbl_EMPBE_Save_Failed_HasErrorAndCode", { code: res.statusCode, msg: res.msg?.join(",") || "Error" }),
            });
          }
        }).catch(err => {
          this.LogPageFormError({ ErrorName: err.name, ErrorMessage: err.message }, "Save_SaveCompanyProfile");
          reject({
            isSuccessful: false,
            popupAlertMsg: this.$t("lbl_EMPBE_Save_Failed_HasError", { msg: err.message }),
            error: err,
          });
        })
      });

    },
    //提交
    async Submit() {
      var data = await this.AfterSaveResult();

      const query = {
        FormId: this.supplierId,
        Action: 'Before_Submit',
        FormType: 'Company_BasicInfo',
        ErrorLog: data.validationErrorLog
      };
      LogService.LogFormDataWithObj(query, data);

      this.$submitFormMessage.ShowProgressWithoutUploadPopup({ isSubmit: true });

      return new Promise((resolve, reject) => {
        CompanyInfoService.SaveCompanyProfile(data).then(result => {
          if (result.isSuccessful) {
            const observer = this.$refs.basicInfoObserver;
            if (!observer || typeof observer.validate !== 'function') {
              this.InitData();
              resolve({
                isSuccessful: true,
                isAllMandatoryFieldFilled: true,
              });
              return;
            }
            observer
            .validate(true)
            .then(async (res) => {
              //写日志
              data.VaildError = res.fIldData;

              if (process.env.VUE_APP_EMP_ENV_NAME?.toLowerCase() == 'ai' || res.valid) {
                this.InitData();
                resolve({
                  isSuccessful: true,
                  isAllMandatoryFieldFilled: true,
                });
              } else {
                this.GetData();
                resolve({
                  isSuccessful: true,
                  isAllMandatoryFieldFilled: false,
                });
              }
            });
          } else {
            this.LogPageFormError({ result: result }, "Submit_SaveCompanyProfile");
            reject({
              isSuccessful: false,
              popupAlertMsg: this.$t("lbl_EMPBE_Submit_Failed_HasErrorAndCode", { code: result.statusCode, msg: result.msg?.join(",") || "Error" }),
            });
          }
        }).catch(err => {
          this.LogPageFormError({ ErrorName: err.name, ErrorMessage: err.message }, "Submit_SaveCompanyProfile");
          reject({
            isSuccessful: false,
            popupAlertMsg: this.$t("lbl_EMPBE_Submit_Failed_HasError", { msg: err.message }),
            error: err,
          });
        });
      });
    },
   
    OpenCatalogue(typeStatus){//类型，是主要的、还是其他产品类�?1 主要类型�?其他类型 
      this.currentTypeStatus = typeStatus; // 保存当前类型
      this.catsMaxLength=typeStatus==1?3:typeStatus==2?30:0;      
      this.categoryInitiSelectItmes=typeStatus==1?this.form.tempcompanyCat:typeStatus==2?this.form.tempcompanyCat_Sub:[];  
      //console.log('this.categoryInitiSelectItmes:'+this.categoryInitiSelectItmes);
      this.showCategoryModal = true;
    }, 
    fromChird_confirmSelectCats(TempFromChildCat){
        if(TempFromChildCat.length==0)
        {
          this.$swal({
          html: this.$t("lbl_EMPBE_PleaseSelect")+this.$t("Lbl_SelectSearchProductCat"),
          showCancelButton: false,
          confirmButtonText: this.$t("lbl_EMPBE_Confirm")
        })
        }else{

          let ids=TempFromChildCat.map(a=>a.subId.toString());//拿到所有的ID
          // 根据类型更新对应的数�?         
          if(this.currentTypeStatus == 1) { 
            this.form.tempcompanyCat = TempFromChildCat;
            //移除此分类重复问�?
            let catsubList=[...this.form.tempcompanyCat_Sub];
            let oterSubList=catsubList.filter(a=>ids.includes(a.subId.toString()));
            if(oterSubList&&oterSubList.length>0){
              oterSubList.forEach(el => {
                let index = this.form.tempcompanyCat_Sub.findIndex(a => a.subId.toString() === el.subId.toString());
                if (index !== -1) {
                  this.form.tempcompanyCat_Sub.splice(index, 1); 
                }
              });
           
          }

          } else if(this.currentTypeStatus == 2) {
            this.form.tempcompanyCat_Sub = TempFromChildCat;
            //移除此分类重复问�?
             var catsubList=[...this.form.tempcompanyCat];
            let oterSubList=catsubList.filter(a=>ids.includes(a.subId.toString()));
            if(oterSubList&&oterSubList.length>0){
              oterSubList.forEach(el => {
                let index = this.form.tempcompanyCat.findIndex(a => a.subId.toString() === el.subId.toString());
                if (index !== -1) {
                  this.form.tempcompanyCat.splice(index, 1); 
                }
              });
            }

          }


        }
      
    },
    // fromChird_deleteSelectedCats(item){ 
    //   var catType=this.currentTypeStatus;
    //   this.removeCats(item,catType,1);
    // }
 
  },
  provide() {
     return {
      showDeleteConfirm: this.handleDelete
    };
  }
};
</script>
<style scoped>
.templateImg {
  height: 150px;
  object-fit: cover;
  object-position: top;
}
.catsecondTitle{
  color: rgba(0, 0, 0, 0.80); 
  font-size: 14px; font-family:
   Inter; font-weight: 700; 
   line-height: 18.20px; 
   word-wrap: break-word;
   /* padding: 8px 0; */
}
.delectSelectedIcon{
  width: 16px; height: 16px; position: relative; overflow: hidden;
  margin-top: -3px;
  cursor: pointer;
  margin-top: -5px;
}
.delectSelectedIcon i{ 
  font-size: 16px;
  color: rgba(0, 0, 0, 0.40);
  font-weight: 600;
}
.selectedCat{
  height: 100%; padding-top: 8px; 
  padding-bottom: 8px; 
  padding-left: 12px; padding-right: 8px; 
  background: rgba(115, 102, 255, 0.10); 
  border-radius: 99px; 
  justify-content: center; align-items: center; gap: 4px; 
  display: inline-flex;
  height: 32px;
  margin: 2px;
}
.selectedCatText{
text-box-trim: trim-both; 
text-box-edge: cap alphabetic; 
justify-content: center; display: flex; 
flex-direction: column; color: rgba(0, 0, 0, 0.80); 
font-size: 14px; 
/* font-family: Inter; */
 font-weight: 500; 
line-height: 14px; word-wrap: break-word
}
.topPartText{
 padding-bottom: 16px;
 color: rgba(0, 0, 0, 0.80); 
 font-size: 14px; 
 /* font-family: Inter;  */
 font-weight: 400; 
 line-height: 21px; 
 word-wrap: break-word;
}
.AdPartText
{
  width: 100%;height: 100%;padding: 16px;
  background: #FCEBED;border-radius: 8px;
  justify-content: flex-start;
  align-items: flex-start;gap: 8px;
  display: inline-flex
}
.AdText{
  flex: 1 1 0; flex-direction: column; justify-content: flex-start; 
    align-items: flex-start; gap: 4px; display: inline-flex;
}
.AdTextTitle{  
    align-self: stretch;  justify-content: center; display: flex; flex-direction: column; color: #CD1515; font-size: 
    14px; 
    /* font-family: Inter;  */
    font-weight: 400; line-height: 20px; word-wrap: break-word
}
.ItemUL{
  align-self: stretch; justify-content: center; display: flex; flex-direction: column;
  padding-left: 20px;;
}
.ItemUL li{
  color: #CD1515;font-size: 14px;
  /* font-family: Inter; */
  font-weight: 700;line-height: 25.20px;word-wrap: break-word;
         list-style: disc; 
}

.has-company-name-br-hint ::v-deep .form-group {
  margin-bottom: 0 !important;
}

.company-name-br-hint {
  margin: 0 0 16px;
  padding: 0 14px;
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.4px;

  a {
    color: #7366ff;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

</style> 
